import { useDispatch } from "react-redux";
import { useFormContext } from "react-hook-form";
import { updateMisc } from "../context/formSlice";
import { updateDialogMisc } from "../context/dialogFormSlice";

/**
 * Generic hook for dispatching context-aware form actions
 * Automatically routes actions to main form or dialog form based on context
 */
const useFormDispatch = () => {
  const dispatch = useDispatch();
  const { isDialogForm } = useFormContext();

  // Generic dispatcher
  const dispatchContextAware = (mainAction, dialogAction, payload) => {
    const action = isDialogForm ? dialogAction : mainAction;
    dispatch(action(payload));
  };

  const dispatchMisc = (payload) => {
    dispatchContextAware(updateMisc, updateDialogMisc, payload);
  };

  return { dispatchContextAware, dispatchMisc, isDialogForm };
};

export default useFormDispatch;
